import * as React from "react";
import { useState, useCallback } from "react";
import { PaginatedItemOverview, ShareButton } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import UsersQueryHelper from "components/users/UsersQueryHelper";
import EntityShareModal from "components/permissions/EntityShareModal";
import UserItemComponent from "./UsersSection/UserItemComponent";
import TeamsDomain from "../../domainActions/TeamsDomain";
const UsersSection = ({ team: { id, name } }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const usersQueryHelper = /* @__PURE__ */ React.createElement(UsersQueryHelper, null);
  const _onLoad = useCallback(
    (pagination) => {
      setLoading(true);
      return TeamsDomain.loadUsersForTeam(id, name, pagination).then((paginatedUsers) => {
        setLoading(false);
        return paginatedUsers;
      });
    },
    [id, name]
  );
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "Users",
      showLoading: loading,
      headerActions: /* @__PURE__ */ React.createElement(ShareButton, { entityId: id, entityType: "team_users", onClick: () => setShowShareModal(true) })
    },
    /* @__PURE__ */ React.createElement(
      PaginatedItemOverview,
      {
        noDataText: "No selected users have been found.",
        onLoad: _onLoad,
        queryHelper: usersQueryHelper,
        overrideItemComponent: UserItemComponent
      }
    ),
    showShareModal && /* @__PURE__ */ React.createElement(
      EntityShareModal,
      {
        entityId: id,
        entityType: "team_users",
        entityTypeTitle: "Team Members",
        entityTitle: name,
        description: "Search for a User or Team to add as collaborator on this team's members.",
        onClose: () => setShowShareModal(false)
      }
    )
  );
};
export default UsersSection;
